<template>
    <div class="main-container">
        <div class="login-wrapper">
          <!-- Logo (above card) -->
          <img :src="logo" alt="Wingio Logo" class="mb-3" height="80">

          <!-- Card -->
          <div class="login-card text-center">
            <div class="alert alert-danger small" role="alert" v-if="error">
              We couldn’t find this email in our system. If you haven't purchased a device yet, 
              <a href="https://www.mywingio.com/">click here to buy one from our website. </a>
            </div>
            <h6 class="mb-1 text-left pl-4 small"><b>Welcome back!</b></h6>

            <form class="p-4">
              <div class="form-group text-left mb-3">
                <label for="email" class="form-label">Email</label>
                <input type="email" id="email" v-model="email" class="form-control" placeholder="Email" required>
              </div>

              <div class="form-group text-left mb-1">
                <label for="password" class="form-label">Password</label>
                <div class="password-input-wrapper">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    v-model="password"
                    id="password"
                    class="form-control"
                    placeholder="Password"
                    required
                  />
                  <span class="toggle-eye" @click="showPassword = !showPassword">
                    <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>
              </div>

              <div class="text-right mb-3">
                <a href="javascript:void(0)" @click="$router.push('/forget-password')" class="small text-decoration-none">Forgot your password?</a>
              </div>

              <button type="submit" class="btn btn-primary w-100" :disabled="isDisabled" @click="login()">
                Log in <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
              </button>
            
              <div class="form-group text-center pt-3" v-if="hideGoogleLogin != 'true'">
                <button type="button" class="btn btn-primary w-100" @click="redirectToGoogleLoginPage" :style="{ 'background': 'white', 'color': 'black' }">
                  <img src="https://hackaday.com/wp-content/uploads/2016/08/google-g-logo.png" alt="Google logo" class="google-logo">
                  Sign in with Google
                </button>
              </div>
              <div class="form-group text-center" v-if="apiBaseUrl != 'https://cloud.kidfirstphone.com:5500/'">
                <!-- Apple Sign-in -->
                <button
                  type="button"
                  class="btn btn-dark w-100 pt-2"
                  @click="redirectToAppleLogin()"
                  style="background: black; color: white;"
                >
                  <img src="/images/applelogo.png"
                      alt="Apple logo"
                      style="height: 18px;" />
                  Sign in with Apple
                </button>
              </div>

            </form>
          </div>

          <p class="recaptcha-text">
            <a href="https://www.mywingio.com/privacy">Privacy Policy</a> and
            <a href="https://www.mywingio.com/terms-conditions">Terms of Service</a> apply.
          </p>
        </div>
    </div>
</template>

<script>
import UserService from "../services/UserService";
export default {
  name: 'Login',
  props: {
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
  },
  data() {
    return {
      isDisabled: false,
      email: null,
      password: null,
      userDetail: null,
      showPassword: false,
      error: this.$route.query.error,
      hideGoogleLogin: false, //this.$route.query.hideGBtn,
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL
    };
  },
  methods: {
    async login() {
      this.isDisabled = true;
      let data = {
        email: this.email,
        password: this.password,
        userAgent: navigator.userAgent,
        isWingioUser: true
      };
      UserService.login(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            const resData = response.data.data;

            // ✅ Check if redirectUrl exists from legacy platform login
            if (resData?.redirectUrl) {
              window.location.href = resData.redirectUrl;
              return; // Stop further execution
            }
            
            if (response.data.enable_two_step_email_verification) {
              this.$router.push({ path: '/verify-otp', query: { email: this.email }});
            } else {
              this.email = null;
              this.password = null;
              localStorage.setItem('token', response.data.data.token);
              //this.$router.push({ path: '/home'})
              document.location = "/kids-device?useDefaultPassword="+response.data.data.useDefaultPassword;
              /*if (response.data.data.user.hasNewUI == true) {
                document.location = "/kids-device";
              } else {
                document.location = "/home";
              }*/
            }
        }).catch((e) => {
          this.isDisabled = false;
          if (e.response.data.invalidEmail == true) {
            this.error = true
          }
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async verifyEmail(iv, encryptedData) {
      this.isDisabled = true;
      let data = {
        iv: iv,
        encryptedData: encryptedData,
        isWingioUser: true
      };
      await UserService.verifyEmail(data)
        .then((response) => {
          //this.userDetail = response.data.data;
          localStorage.setItem('token', response.data.data.token);
          //this.$router.push({ path: '/home'})
          document.location = "/";
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async isUserLogin() {
      await UserService.isUserLogin()
        .then((response) => {
          document.location = "/kids-device";
        }).catch((e) => {
        });
    },
    togglePasswordDisplay(showPassword) {
      if (showPassword == true) {
        $('#password-input').attr('type', 'text');
      } else {
        $('#password-input').attr('type', 'password');
      }
      this.showPassword = showPassword;
    },
    redirectToGoogleLoginPage() {
      //window.open(process.env.VUE_APP_API_URL + "users/auth/google", "_blank");
      window.location.href = process.env.VUE_APP_API_URL + "users/auth/google"
    },
    redirectToAppleLogin() {
        const clientId = 'com.parent.mywingio';
        const redirectUri = encodeURIComponent('https://parent.mywingio.com:5500/api/v1/admin/users/apple-callback'); // new static page

        const state = Math.random().toString(36).substring(2);

        const url = `https://appleid.apple.com/auth/authorize` +
                    `?response_type=code` +
                    `&response_mode=form_post` +
                    `&client_id=${clientId}` +
                    `&redirect_uri=${redirectUri}` +
                    `&scope=name%20email` +
                    `&state=${state}`;

        window.location.href = url;
    },
    async verifyAppleLogin(code, id_token) {
        this.isDisabled = true;
        await UserService.verifyAppleLogin({ code, id_token })
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    }


  },
  beforeMount() {
    if (this.$route.query.iv && this.$route.query.encryptedData) {
      this.verifyEmail(this.$route.query.iv,this.$route.query.encryptedData);
    }
    if (this.$route.query.token) {
      localStorage.setItem('token', this.$route.query.token);
      document.location = "/kids-device";
    }
    this.isUserLogin();
    
    /*if (this.$route.query.hideGBtn) {
      localStorage.setItem('hideGoogleLogin', this.$route.query.hideGBtn);
    } else {
      localStorage.removeItem('hideGoogleLogin');
    }*/

    if (this.$route.query.code && this.$route.query.id_token) {
      
      this.verifyAppleLogin(this.$route.query.code, this.$route.query.id_token);
      return; // Stop further execution until Apple login finishes
    }
  },
}
</script>
<style scoped>
.login-wrapper {
  max-width: 400px;
  text-align: center;
}
.login-card {
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  background: #fff;
}
.recaptcha-text {
  font-size: 11px;
  color: #6c757d;
  margin-top: 1rem;
}
.password-input-wrapper {
  position: relative;
}

.password-input-wrapper input {
  padding-right: 2.5rem; /* space for the eye icon */
}

.toggle-eye {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
}

</style>